import { Search, X } from "lucide-react";
import { useTripTypes } from "../lib/tripTypes";

export const emptyFilters = { q: "", country: "", state: "", trip_type: "" };

export const applyFilters = (items, f) => items.filter((v) => {
  const text = `${v.title} ${v.location} ${v.description || ""} ${v.broker_company || ""}`.toLowerCase();
  return (!f.q || text.includes(f.q.toLowerCase()))
    && (!f.country || v.country === f.country)
    && (!f.state || (v.states || []).includes(f.state))
    && (!f.trip_type || v.trip_type === f.trip_type);
});

export const LocationFilters = ({ items, value, onChange }) => {
  const types = useTripTypes();
  const countries = [...new Set(items.map((v) => v.country).filter(Boolean))].sort();
  const states = [...new Set(items.flatMap((v) => v.states || []))].sort();
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value, ...(k === "country" && e.target.value !== "United States" ? { state: "" } : {}) });
  const active = Object.values(value).some(Boolean);
  return (
    <div data-testid="location-filters" className="mt-5 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
      <label className="relative lg:col-span-2">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <input data-testid="filter-search" value={value.q} onChange={set("q")} placeholder="Search destination, trip or partner" className="lux-input !py-2.5 !pl-9" />
      </label>
      <select data-testid="filter-country" value={value.country} onChange={set("country")} className="lux-input !py-2.5">
        <option value="">All countries</option>
        {countries.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <select data-testid="filter-state" value={value.state} onChange={set("state")} disabled={value.country && value.country !== "United States"} className="lux-input !py-2.5 disabled:opacity-40">
        <option value="">All US states</option>
        {states.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <div className="flex gap-2">
        <select data-testid="filter-trip-type" value={value.trip_type} onChange={set("trip_type")} className="lux-input !py-2.5">
          <option value="">Any booking window</option>
          {Object.entries(types).map(([k, t]) => <option key={k} value={k}>{`${t.label} (${t.min}–${t.max} mo)`}</option>)}
        </select>
        {active && <button data-testid="filter-clear" onClick={() => onChange(emptyFilters)} className="btn-ghost px-3" aria-label="Clear filters"><X className="w-4 h-4" /></button>}
      </div>
    </div>
  );
};
